import { PartnerService, UserService } from '@duck/api-definitions'

const S = PartnerService.AssignmentDetailsStatus

type Details = PartnerService.AssignmentDetails

export type RosterSortColumn = 'name' | 'startDate' | 'submitDate' | 'status'

const isGraded = (d: Details): boolean => !!d.feedback && d.grade !== undefined

const rosterPersonName = (d: Details, persons: UserService.Person[]): string => {
  const person = persons.find((p) => p.id === d.personId)
  return (person ? `${person.firstName || ''} ${person.lastName || ''}`.trim() : '') || d.personId
}

/**
 * Combined status + grade ordering (ascending = least → most progress):
 * Sent 0 · Started 1 · Forfeited 2 · Submitted/processing 3 · graded 4 + grade/10.
 */
export const getRosterStatusSortValue = (d: Details): number => {
  if (isGraded(d)) return 4 + (d.grade as number) / 10
  switch (d.status) {
    case S.Sent:
      return 0
    case S.Started:
      return 1
    case S.Forfeited:
      return 2
    case S.Submitted:
      return 3 // submitted but not yet graded (processing)
    default:
      return 0
  }
}

export const sortRosterDetails = (
  details: Details[],
  persons: UserService.Person[],
  sortColumn: string | null,
  sortDirection: 'asc' | 'desc' | null
): Details[] => {
  if (sortColumn === null || sortDirection === null) return details

  return [...details].sort((a, b) => {
    let comparison = 0

    if (sortColumn === 'name') {
      comparison = rosterPersonName(a, persons).localeCompare(rosterPersonName(b, persons))
    } else if (sortColumn === 'status') {
      comparison = getRosterStatusSortValue(a) - getRosterStatusSortValue(b)
    } else {
      // Date columns (startDate | submitDate): blanks always sink to the bottom,
      // independent of sort direction (matches cohortPeopleTable.utils convention).
      const aValue = a[sortColumn as 'startDate' | 'submitDate']
      const bValue = b[sortColumn as 'startDate' | 'submitDate']
      if (aValue === undefined || aValue === null) return 1
      if (bValue === undefined || bValue === null) return -1
      comparison = new Date(aValue).getTime() - new Date(bValue).getTime()
    }

    return sortDirection === 'asc' ? comparison : -comparison
  })
}
